export default "__VITE_ASSET__CnjHmglC__"